export interface FilesListParams {
  page?: number
  items?: number
  q?: Record<string, unknown>
}

export type FilesInfiniteParams = Omit<FilesListParams, 'page'>

export interface CalendarFilesParams {
  filters: Record<string, unknown>
  startDate: string
  endDate: string
}

export const filesKeys = {
  all: (workspaceId: number | undefined) => ['files', workspaceId] as const,

  partialInfinite: (workspaceId: number | undefined) => [...filesKeys.all(workspaceId), 'infinite'] as const,

  infinite: (workspaceId: number | undefined, params: FilesInfiniteParams) =>
    [...filesKeys.all(workspaceId), 'infinite', params] as const,

  partialCalendar: (workspaceId: number | undefined) =>
    [...filesKeys.partialInfinite(workspaceId), 'calendar'] as const,

  calendar: (workspaceId: number | undefined, params: CalendarFilesParams) =>
    [...filesKeys.partialInfinite(workspaceId), 'calendar', params] as const,

  list: (workspaceId: number | undefined, params: FilesListParams) =>
    [...filesKeys.all(workspaceId), 'list', params] as const,

  detail: (workspaceId: number | undefined, fileKey: string) =>
    [...filesKeys.all(workspaceId), 'detail', fileKey] as const,

  update: (workspaceId: number | undefined, fileKey: string) =>
    [...filesKeys.all(workspaceId), 'update', fileKey] as const,

  partialRecentsInfinite: (workspaceId: number | undefined) =>
    [...filesKeys.all(workspaceId), 'recents', 'infinite'] as const,

  recentsInfinite: (workspaceId: number | undefined, params: FilesInfiniteParams) =>
    [...filesKeys.all(workspaceId), 'recents', 'infinite', params] as const,

  partialUploadsInfinite: (workspaceId: number | undefined) =>
    [...filesKeys.all(workspaceId), 'uploads', 'infinite'] as const,

  uploadsInfinite: (workspaceId: number | undefined, params: FilesInfiniteParams) =>
    [...filesKeys.all(workspaceId), 'uploads', 'infinite', params] as const,
}

export type FilesPartialInfiniteKey = ReturnType<typeof filesKeys.partialInfinite>
export type FilesInfiniteQueryKey = ReturnType<typeof filesKeys.infinite>
export type FilesPartialCalendarKey = ReturnType<typeof filesKeys.partialCalendar>
export type FilesCalendarQueryKey = ReturnType<typeof filesKeys.calendar>
export type FilesDetailQueryKey = ReturnType<typeof filesKeys.detail>
export type FilesUpdateMutationKey = ReturnType<typeof filesKeys.update>
export type FilesPartialRecentsInfiniteKey = ReturnType<typeof filesKeys.partialRecentsInfinite>
export type FilesRecentsInfiniteQueryKey = ReturnType<typeof filesKeys.recentsInfinite>
